export interface Attachments {
  estateId: string;
  files: AttFile[];
}

export interface AttFile {
  fileCategory: FileCategory;
  name: string;
  uploadDate: number;
  url: string;
  visibleInApp: boolean;
  referenceId: string | null;
}

export enum FileCategory {
  FINANCIAL = 'financial',
  PROTOCOL = 'protocol',
  AGREEMENT = 'agreement',
  OTHER = 'other'
}
